import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BaseComponent } from '../../base-component/base-component';
import { MENU_ITEMS, ISideMenuItem } from './side-menu';
import { filter, takeUntil } from 'rxjs/operators';
import { UserDetail } from '../../../models/users.model';
import { DataContextService } from '../../../services/datacontext.service';
import { PreferencesCurrentViewService } from '../../../services/preferences/preferences-current-view';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.less'],
})
export class SideMenuComponent extends BaseComponent implements OnInit {
  isExpanded = false;
  menuItems = MENU_ITEMS;
  userDetails: UserDetail;
  isActiveView: boolean = true;
  constructor(private router: Router, private preferenceCurrentViewService: PreferencesCurrentViewService) {
    super();
    this.userDetails = DataContextService.UserData;
    this.preferenceCurrentViewService.currentView$.subscribe((res) => {
      this.isActiveView = res.building.length ? true : false;
    })
  }

  ngOnInit(): void {
    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe((e: NavigationEnd) => {
        this.routerChangeHandler(e.urlAfterRedirects);
        this.collapse();
      });   
  }

  expand(): void {
    this.isExpanded = true;
    this.expandActiveMenuItem();
  }

  collapse(): void {
    this.isExpanded = false;
    this.closeAllMenuItem();
  }

  menuItemExpandedHandler(item: ISideMenuItem): void {
    this.expand();
    item.expanded = true;
  }

  private routerChangeHandler(url: string): void {
    this.menuItems = this.menuItems.map((item) => {
      item.active = this.isActiveRoute(item.route);

      if (item.children) {
        item.children = item.children.map((child) => {
          child.active = item.active ? this.isActiveRoute(child.route) : false;
          return child;
        });
      }

      return item;
    });
  }

  private closeAllMenuItem(): void {
    this.menuItems = this.menuItems.map((item) => {
      item.expanded = false;
      return item;
    });
  }

  private expandActiveMenuItem(): void {
    this.menuItems = this.menuItems.map((item) => {
      item.expanded = item.active;
      return item;
    });
  }

  private isActiveRoute(route: string): boolean {
    return this.router.isActive(route, false);
  }
}
